export {default as chris} from './avatar-chris.png';
export {default as chris2x} from './avatar-chris@2x.png';
export {default as james} from './avatar-james.png';
export {default as james2x} from './avatar-james@2x.png';
export {default as map} from './map.png';
export {default as map2x} from './map@2x.png';
export {default as Sprite} from './sprite';
